import { css } from "lit";

export const holloHeaderStyles = css`
  .hollo-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px 6px 16px;
    background: rgba(250, 250, 250, 0.75);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  }
  .hollo-header-minimal {
    justify-content: space-between;
    padding: 16px 16px 8px 16px;
  }
  @media (max-width: 460px) {
    .hollo-header {
      height: auto;
    }
  }
  .hollo-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .hollo-header-avatar {
    flex-shrink: 0;
  }
  .hollo-user-meta {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .hollo-header-title {
    font-weight: 700;
    color: #111827;
    font-size: 16px;
  }
  .hollo-right {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
  }

  .hollo-flag-btn {
    width: auto;
    height: 36px;
    border: none;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #EDEDED;
    cursor: pointer;
    font-size: 16px;
    padding: 0 10px 0 4px;
    flex-shrink: 0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .hollo-flag-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
  }
  
  .hollo-chevron-down {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  
  .hollo-chevron-down svg {
    display: block;
    transition: transform 0.2s ease;
  }
  
  .hollo-flag-btn[aria-expanded="true"] .hollo-chevron-down svg {
    transform: rotate(180deg);
  }
  .hollo-pen-btn {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 999px;
    display: grid;
    place-items: center;
    background: transparent;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  .hollo-pen-btn:hover {
    background: rgba(0, 0, 0, 0.04);
  }
  .hollo-pen-btn svg {
    display: block;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  .hollo-pen-btn svg path {
    transition: stroke 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  .hollo-pen-btn:hover svg {
    stroke: var(--hollo-highlight-color, #3784ff);
  }
  .hollo-pen-btn:hover svg path {
    stroke: var(--hollo-highlight-color, #3784ff);
  }
  .hollo-flag-img {
    width: 28px;
    height: 28px;
    object-fit: cover;
    border-radius: 50%;
    flex-shrink: 0;
  }
  
  .flag-emoji {
    display: block;
    font-size: 18px;
    line-height: 1;
    flex-shrink: 0;
  }
  .hollo-flag-emoji {
    line-height: 1;
  }
  .hollo-icon-btn {
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 12px;
    display: grid;
    place-items: center;
    cursor: pointer;
    background: #ecfdf5;
    color: #065f46;
  }

  .hollo-switch {
    position: relative;
    width: 44px;
    height: 24px;
  }
  .hollo-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .hollo-slider {
    position: absolute;
    inset: 0;
    border-radius: 999px;
    background: #e5e7eb;
    transition: background 0.2s;
    cursor: pointer;
  }
  .hollo-slider::before {
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    top: 3px;
    left: 3px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    transition: transform 0.2s;
  }
  .hollo-switch input:checked + .hollo-slider {
    background: #fb7185;
  }
  .hollo-switch input:checked + .hollo-slider::before {
    transform: translateX(20px);
  }
  .hollo-user-name {
    color: #070310;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.01em;
    text-transform: none;
  }
  .hollo-user-phone {
    background: var(
      --hollo-phone-number-gradient,
      linear-gradient(
        90deg,
        #ec4899 0%,
        #a855f7 40%,
        #3b82f6 70%,
        #60a5fa 100%
      )
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-align: left;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: -0.01em;
    text-transform: none;
    text-decoration: none;
    display: inline-block;
  }
  .hollo-live-toggle {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 50%;
    display: grid;
    place-items: center;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    transition: background 0.2s ease;
  }
  .hollo-live-toggle:hover {
    background: #2563eb;
  }
  .hollo-live-toggle svg {
    width: 32px;
    height: 32px;
  }
  .live-on {
    background: #bbc6ca;
  }
  .live-off {
    background: #00adee;
  }
  .hollo-live-toggle-icon {
    display: flex;
    align-items: bottom;
    justify-content: center;
  }
  .hollo-menu-btn {
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    background: transparent;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    color: #000000;
    padding: 0;
    flex-shrink: 0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .hollo-menu-btn:hover {
    background: rgba(0, 0, 0, 0.04);
    color: #ef4444;
  }
  .hollo-menu-btn svg {
    display: block;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .hollo-menu-btn:hover svg path {
    stroke: #ef4444;
  }
  .gap-4 {
    gap: 4px;
  }
  .hollo-skel-name {
    display: inline-block;
    width: 140px;
    height: 16px;
    border-radius: 6px;
    background: linear-gradient(90deg, #f2f4f8 0%, #eaeef4 50%, #f2f4f8 100%);
    background-size: 200% 100%;
    animation: hollo-skel-shimmer 1.2s ease-in-out infinite;
  }
  @keyframes hollo-skel-shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
